/* eslint-disable */
/*
 * Chartist.js plugin to insert vertical line in a line chart.
 * used in metric charts (single goal view) to display soft and hard deadline
 *
 */
(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["chartist"], factory);
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory(require("chartist"));
  } else {
    factory((typeof global !== "undefined" ? global : window).Chartist);
  }
})(function (Chartist) {
  "use strict";

  var defaultOptions = {
    position: undefined,
    label: undefined,
    className: "vertical-line",
  };

  var VerticalLine = function (chart, chartRect, options) {
    var labelClassName = options.className + "-label";
    var positionLabelClassName = options.className + "-position-label";
    var labelEl = document.querySelector("." + labelClassName);
    // added second label to display dates of deadlines
    var positionLabelEl = document.querySelector("." + positionLabelClassName);

    if (!labelEl) {
      labelEl = document.createElement("span");
      labelEl.classList.add(labelClassName);
      labelEl.style.position = "absolute";
      chart.container.append(labelEl);
    }
    labelEl.style.display = "none";

    if (!positionLabelEl) {
      positionLabelEl = document.createElement("span");
      positionLabelEl.classList.add(positionLabelClassName);
      positionLabelEl.style.position = "absolute";
      chart.container.append(positionLabelEl);
    }
    positionLabelEl.style.display = "none";

    this.show = function (x) {
      // left is modified to fit the expected layout of the chart
      var labelRect = labelEl.getBoundingClientRect();
      labelEl.innerHTML = options.label || "";
      labelEl.style.left = `${x - labelRect.width / 2 - 44}px`;
      labelEl.style.display = "block";

      var positionLabelRect = positionLabelEl.getBoundingClientRect();
      positionLabelEl.innerHTML = options.positionLabel || "";
      positionLabelEl.style.left = `${x - positionLabelRect.width / 2 - 44}px`;
      positionLabelEl.style.display = "block";

      chart.svg.elem(
        "line",
        {
          x1: x,
          x2: x,
          y1: chartRect.y1 + 5,
          y2: chartRect.y2 + labelRect.height - 16,
        },
        options.className
      );
    };
  };

  Chartist.plugins = Chartist.plugins || {};
  Chartist.plugins.verticalLine = function (options) {
    options = Chartist.extend({}, defaultOptions, options);

    return function (chart) {
      if (!(chart instanceof Chartist.Line)) {
        return;
      }

      var position = {};

      chart.on("data", function () {
        position.index = chart.data.labels.indexOf(options.position);
      });

      chart.on("draw", function (data) {
        if (
          position.index !== -1 &&
          data.type === "point" &&
          data.index === position.index
        ) {
          position.x = data.x;
        }
      });

      chart.on("created", function (data) {
        if (position.index === -1) {
          return;
        }

        var verticalLine = new VerticalLine(chart, data.chartRect, options);
        verticalLine.show(position.x);
      });
    };
  };
});
